import React from "react";
import { useAppSelector } from "../../../../services/hooks";
import { companyGuidSelector } from "../../../../services/selectors/auth.selectors";
import { useGetCompanyUsageDetailQuery } from "../../../../services/api/plansAdminApi";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import { AiCreditUsageDetail } from "../../../aiCreditUsageDetail/AiCreditUsageDetail";
import styles from "./planUsageTab.module.css";

export const PlanUsageTab: React.FC = () => {
  const companyGuid = useAppSelector(companyGuidSelector);
  const { data, isLoading, isError } = useGetCompanyUsageDetailQuery(companyGuid!, {
    skip: !companyGuid,
  });

  if (isLoading) {
    return <div className={styles.loading}>{t("LOADING")}</div>;
  }

  if (isError || !data) {
    return <div className={styles.loading}>Failed to load usage data.</div>;
  }

  return <AiCreditUsageDetail data={data} />;
};
